<div class="list-area bg-[#F8F8F8] h-[100vh]">
  <div class="container mx-auto py-14 px-4">
    <div class="py-6 bg-gray-50">
      <!-- Header Section -->
      <div class="flex justify-between items-center">
        <div class="mb-7">
          <h1 class="text-2xl font-semibold text-gray-800 mb-1">List Page</h1>
          <p class="text-sm text-gray-500">View all of Your Clients Information</p>
        </div>
        <div class="flex gap-2">
          <p-button icon="pi pi-download" label="Export" severity="secondary"></p-button>
          <p-button icon="pi pi-plus" label="Add New" severity="primary" (onClick)=" addTask()"></p-button>
        </div>
      </div>

      <!-- Tabs -->
      <p-tabMenu [model]="tabs" [activeItem]="activeTab" class="mt-4 border-b"></p-tabMenu>

      <!-- Content Placeholder -->
    </div>

    <div class="mt-6 p-4 bg-white shadow rounded-lg">
      <div class="list-content bg-white rounded-[20px] lg:p-[40px]"  *ngIf="activeTab.label =='All Clients'">
        <div class="filters-container flex justify-between w-full items-center mb-5">
          <div class="flex items-center">
            <!-- Search Input -->
              <p-iconfield iconPosition="left">
                <p-inputicon>
                    <i class="pi pi-search"></i>
                </p-inputicon>
                <input
                    pInputText
                    type="text"
                    [(ngModel)]="searchValue"
                    (input)="filterOrders()"
                    placeholder="Global Search"
                />
            </p-iconfield>
          </div>

          <div class="flex space-x-10 items-center justify-end">
            <!-- Date Range Picker -->
            <p-calendar
              [(ngModel)]="dateRange"
              selectionMode="range"
              showIcon="true"
              placeholder="Select Date"
            ></p-calendar>

            <!-- Filters Button -->
            <p-button
              icon="pi pi-filter"
              label="Filters"
              (click)="toggleFilter($event, filterPanel)"
              severity="secondary"
            ></p-button>
          </div>
        </div>
        <p-overlayPanel #filterPanel>
          <div class="filter-options w-[9rem]">
            <h4>Filters</h4>
            <p-divider />
            <label class="block">Order Status:</label>
            <p-dropdown
              [options]="statusOptions"
              [(ngModel)]="selectedStatus"
              placeholder="Select Status"
              class="block my-2 w-full"
            ></p-dropdown>

            <p-button
              label="Apply Filters"
              (click)="applyFilters()"
              severity="primary"
              ngClass="block w-full"
            ></p-button>
          </div>
        </p-overlayPanel>
        <!-- PrimeNG Table -->
        <div class="table-container">
          <p-table
            [value]="filteredOrders"
            [paginator]="true"
            [rows]="5"
            [rowsPerPageOptions]="[5, 10, 20]"
            [globalFilterFields]="['client', 'date', 'order']"
            stripedRows
          >
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
                <th pSortableColumn="client">
                  Clients <p-sortIcon field="client"></p-sortIcon>
                </th>
                <th pSortableColumn="date">
                  Date <p-sortIcon field="date"></p-sortIcon>
                </th>
                <th pSortableColumn="order">
                  Order <p-sortIcon field="order"></p-sortIcon>
                </th>
                <th>Items</th>
                <th>Total</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-order>
              <tr>
                <td><p-tableCheckbox [value]="order" /></td>
                <td>{{ order.client }}</td>
                <td>{{ order.date }}</td>
                <td>{{ order.order }}</td>
                <td>{{ order.items }}</td>
                <td>{{ order.total }}</td>
                <td>
                  <p-tag
                    [value]="order.status"
                    [severity]="order.status === 'Paid' ? 'success' : 'danger'"
                  ></p-tag>
                </td>
                <td>
                  <div class="flex items-center icon-box">
                    <p-button icon="pi pi-clone" variant="text"></p-button>
                    <p-button icon="pi pi-eye" variant="text"></p-button>

                    <!-- Ellipsis button to open overlay panel -->
                    <p-button
                      icon="pi pi-ellipsis-h"
                      variant="text"
                      (click)="toggleMenu($event, order, menuPanel)"
                    ></p-button>

                    <!-- PrimeNG OverlayPanel (dropdown) -->
                    <p-overlayPanel #menuPanel>
                      <ul class="p-0 m-0 list-none">
                        <li>
                          <p-button label="Edit" icon="pi pi-pencil" variant="text" (click)="editOrder(order)"></p-button>
                        </li>
                        <li>
                          <p-button label="Delete" icon="pi pi-trash" variant="text" (click)="confirmDelete()"></p-button>
                        </li>
                      </ul>
                    </p-overlayPanel>
                  </div>
                </td>

              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7">No records found.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div *ngIf="activeTab.label !=='All Clients'">
        <p class="text-gray-600" >Showing content for <strong>{{ activeTab.label }}</strong></p>
      </div>
    </div>

  </div>
</div>
<p-confirmDialog></p-confirmDialog>
<app-fiber-edit
  [displayModal]="displayModal"
  [order]="selectedOrder"
  (closeModal)="closeEditModal()">
</app-fiber-edit>
<app-fiber-create  [displayTaskModal]="displayTaskModal"
(closeModal)="closeTaskModal()">

</app-fiber-create>
